import React from 'react'

const AddItemIcon = (props) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M5.81299 8.99994H8.84406' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M11.4434 8.99994H12.1869' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8.95996 5.8551V12.1468' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9 17C4.58294 17 1 13.4192 1 9C1 4.58083 4.58083 1 9 1C13.4192 1 17 4.58083 17 9' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
export default AddItemIcon
